import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** FETCH KYC SOURCED REPORT DETAILS START *********************** */
export const getKYCSourcedReportDetails = (getData: any) => {
	const data = {
		KYCSourcedReportDetailsToken: getData,
	};
	const url = `${API_URL}getKYCSourcedDetailsBasedOnBranch`;
	return makeApiCall(url, data);
};
/** ***************** FETCH KYC SOURCED REPORT DETAILS END *********************** */
